import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import { Routes } from '../../routes';

import Loader from '../../components/Loader';
const load = (Component) => (props) => (
    <Suspense fallback={<Loader />}>
        <Component {...props} />
    </Suspense>
);

const Header = load(lazy(() => import('../../layouts/approvers/header')));
const Sidebar = load(lazy(() => import('../../layouts/approvers/sidebar')));
const Footer = load(lazy(() => import('../../layouts/approvers/footer')));
const Assets = load(lazy(() => import('../../layouts/approvers/assets')));
const ApproversNotFound = load(lazy(() => import('./404-approvers')));
const Dashboard = load(lazy(() => import('./dashboard')));
const ValidasiPengajuan = load(lazy(() => import('./validasi-pengajuan/validasi-pengajuan')));
const DetailPengajuan = load(lazy(() => import('./validasi-pengajuan/detail-pengajuan')));
const RiwayatPengajuan = load(lazy(() => import('../riwayat-pengajuan/unit/riwayat-pengajuan-list')));
const RiwayatPengajuanDetailPpbj = load(lazy(() => import('../riwayat-pengajuan/unit/riwayat-pengajuan-detail-ppbj')));
const RiwayatPengajuanDetailPtum = load(lazy(() => import('../riwayat-pengajuan/unit/riwayat-pengajuan-detail-ptum')));
const ValidasiPengajuanFinance = load(lazy(() => import('../approvers-finance/validasi-pengajuan/validasi-pengajuan')));
const DetailPengajuanFinance = load(lazy(() => import('../approvers-finance/validasi-pengajuan/detail-pengajuan')));
const RiwayatPengajuanFinance = load(lazy(() => import('../riwayat-pengajuan/finance/riwayat-pengajuan-list')));
const RiwayatPengajuanDetailFinanceBkkb = load(lazy(() => import('../riwayat-pengajuan/finance/riwayat-pengajuan-detail-bkkb')));
const RiwayatPengajuanDetailFinanceBtkb = load(lazy(() => import('../riwayat-pengajuan/finance/riwayat-pengajuan-detail-btkb')));
const RiwayatPengajuanDetailFinanceBj = load(lazy(() => import('../riwayat-pengajuan/finance/riwayat-pengajuan-detail-bj')));

const Index = () => {
    return (<>
        <div className="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
            <Header />
            <div className="app-main">
                <Sidebar />
                <div className="app-main__outer">
                    <div className="app-main__inner">
                        <Switch>
                            <Route
                                path={Routes.DashboardApprovers.path}
                                render={props => <Dashboard {...props} />}
                            />
                            <Route
                                path={Routes.ValidasiPengajuanApprovers.path}
                                render={props => <ValidasiPengajuan {...props} />}
                            />
                            <Route
                                path={Routes.DetailPengajuanApprovers.path}
                                render={props => <DetailPengajuan {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanApprovers.path}
                                render={props => <RiwayatPengajuan {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailPpbjApprovers.path}
                                render={props => <RiwayatPengajuanDetailPpbj {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailPtumApprovers.path}
                                render={props => <RiwayatPengajuanDetailPtum {...props} />}
                            />
                            <Route
                                path={Routes.ValidasiPengajuanKeuanganApprovers.path}
                                render={props => <ValidasiPengajuanFinance {...props} />}
                            />
                            <Route
                                path={Routes.DetailPengajuanKeuanganApprovers.path}
                                render={props => <DetailPengajuanFinance {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanKeuanganApprovers.path}
                                render={props => <RiwayatPengajuanFinance {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailKeuanganApprovers.path.replace(':type', 'bkkb')}
                                render={props => <RiwayatPengajuanDetailFinanceBkkb {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailKeuanganApprovers.path.replace(':type', 'btkb')}
                                render={props => <RiwayatPengajuanDetailFinanceBtkb {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailKeuanganApprovers.path.replace(':type', 'bj')}
                                render={props => <RiwayatPengajuanDetailFinanceBj {...props} />}
                            />
                            <Route render={() => <ApproversNotFound />} />
                        </Switch>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>

        <ToastContainer />
        <Assets />
    </>);
}

export default Index;